import { render, staticRenderFns } from "./AgeVerifier.vue?vue&type=template&id=0bffd056&"
import script from "./AgeVerifier.vue?vue&type=script&lang=js&"
export * from "./AgeVerifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports